export default "__VITE_ASSET__BkMloWt4__"